interface MobileURLSource {
  type: string;
  file: string;
}

interface PlaylistEntry {
  sources: MobileURLSource[];
}

const retrieveMobileURL = async (videoId: string) => {
  const endpoint = `https://cdn.jwplayer.com/v2/media/${videoId}`;

  try {
    const data = await fetch(endpoint);

    if (data.ok) {
      const json = await data.json();

      const mobileUrl = json?.playlist?.reduce((result: string, playlistEntry: PlaylistEntry) => {
        if (result) {
          return result;
        }

        const find = playlistEntry?.sources?.find(
          ({ type }: MobileURLSource) => type === 'application/vnd.apple.mpegurl'
        );

        return find?.file ?? result;
      }, '' as string);

      return mobileUrl;
    }

    return '';
  } catch (_) {
    return '';
  }
};

export default retrieveMobileURL;
